module.exports = __webpack_public_path__ + "assets/img/network-1.2f0a96e4.svg";